var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMergeGateway(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 972.39 1200",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M710.81,430.08c-113.18,26.23-221.41,69.47-320.66,127.37C229,455.13,95.02,310.75,5.46,135.65c-12.29-24.1-2.36-53.88,22.45-64.98L173.71,4.27c22.68-10.4,49.62-1.18,61.2,20.79,101.14,193.76,273.4,337.67,475.9,405.02Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M173.7,1195.69l-146.03-66.4c-24.58-11.34-34.74-40.88-22.45-64.98C182.45,718.13,534.06,491.76,922.53,473.8c27.18-1.18,49.86,20.32,49.86,47.26v160.44c0,25.05-19.38,45.61-44.43,47.02-292.77,15.59-557.66,186.2-693.3,446.37-11.58,22.21-38.52,31.19-61.2,20.79h.24Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMergeGateway);
export default __webpack_public_path__ + "static/media/merge-gateway.341e4af9628b012352c76b756ea8eb4a.svg";
export { ForwardRef as ReactComponent };